/**
 * Store-wide "Preis auf Anfrage" for native Horizon product cards
 * (collection grids, /search results, product recommendations).
 *
 * assets/base.css hides <product-price> and <quick-add-component> inside
 * every .product-card by default (so there's no flash of a real price).
 * This script:
 *   - marks the gift card's card with [data-anfrage-allow], which the
 *     CSS uses to restore its price + quick-add — it stays purchasable;
 *   - injects a "Preis auf Anfrage" label into every other card, in the
 *     same slot the price occupied.
 *
 * Runs on load and re-runs via a MutationObserver, because Horizon
 * re-renders the whole card grid on every AJAX filter / sort / paginate
 * (same reason hygeon-filters-fix.js needs an observer).
 *
 * The homepage's own custom cards (snippets/hygeon-tabs-card.liquid) are
 * NOT native .product-card elements and are handled in that snippet
 * directly — this script only touches Horizon's native cards.
 */
(function () {
  'use strict';

  var GIFT_CARD_HANDLE = 'gift-card';
  var LABEL = 'Preis auf Anfrage';
  var DONE_ATTR = 'data-anfrage-card-done';

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function processCard(card) {
    if (card.hasAttribute(DONE_ATTR)) return;
    var handle = handleOf(card);
    if (!handle) return;

    card.setAttribute(DONE_ATTR, '');

    // 2026-09-11: an approved B2B customer sees real prices + quick-add
    // on every card, not just the gift card's — see layout/theme.liquid
    // for where window.HygeonB2BApproved is set from the real customer tag.
    if (handle === GIFT_CARD_HANDLE || window.HygeonB2BApproved) {
      card.setAttribute('data-anfrage-allow', '');
      return;
    }

    // Put the "Preis auf Anfrage" label where the price was.
    var priceEl = card.querySelector('product-price');
    if (priceEl && !priceEl.parentNode.querySelector('.hygeon-anfrage-card-price')) {
      var span = document.createElement('span');
      span.className = 'hygeon-anfrage-card-price';
      span.textContent = LABEL;
      priceEl.parentNode.insertBefore(span, priceEl.nextSibling);
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('product-card, .product-card').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('product-card, .product-card')) {
          processCard(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
